<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link
        :to="{ name: 'EXCMCaseCreate' }"
        class="btn btn-sm btn-primary float-right mb-1"
      >
        {{$t('buttons.create')}}
      </router-link>
    </template>
    <template #filtering>
      <b-row>
        <b-col class="text-right mt-1">
          <div class="btn-group mb-2">
            <span class="mr-2 mt-2" v-if="totalItems">{{$t('global.totalItems')}}: {{totalItems}}</span>
            <model-select class="mr-2" style="height: 34px; width: 265px" v-model="searchParams.caseType" :options="caseTypeOptions" :placeholder="$t('views.excmcase.form.caseType')" @input="isFilteringVisible = $event"></model-select>
            <input type="search" class="mr-2 form-control" style="width: auto"
                   :placeholder="$t('buttons.quickSearch')" @input="getPage(searchParams)"
                   v-model.lazy="searchParams.caseQuickSearch" v-debounce="delay">
            <button v-if="isFilteringVisible"
                    type="button"
                    class="btn btn-sm fa fa-sync fa-lg btn-link"
                    @click="clearFilters()">
            </button>
            <b-button
              v-bind:class="{ 'btn-sm': mobileView, 'btn-sm': !mobileView }"
              v-b-tooltip.hover :title="$t('buttons.search')"
              v-b-toggle.excmcase_search_collapse variant="primary">
              <i class="fa fa-filter"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-collapse id="excmcase_search_collapse" class="mt-2" @input="isFilteringVisible = $event">
            <Filtering :deviceTypeOptions="deviceTypeOptions"
                       :externalStatus="externalStatus"
                       :isSalesRepresentative="isSalesRepresentative"
                       :isWholesaler="isWholesaler"
                       :idCasesType="searchParams.caseType"
                       :caseTypeOptions="caseTypeOptions"
                       @getPage="getPage($event)"
                       ref="filtering"
            ></Filtering>
          </b-collapse>
        </b-col>
      </b-row>
    </template>
    <template #body>
      <List ref="list" :display-assigned="displayAssigned" :search-params="searchParams" />
    </template>
  </base-table-wrapper>
</template>

<script>
import debounce from 'v-debounce' // search params with delay when typing
import { checkPagePermission, checkPermission, getUserRoles } from '@/utils/checkRoles.js'
import List from '@/components/Dashboard/Views/excmcase/Table'
import Filtering from './components/Filtering/Filtering'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import ApiService from '@/utils/ApiService'
import { ModelSelect } from 'vue-search-select'
import getId from '@/utils/getIdFromLink'
import { mapGetters } from 'vuex'

export default {
  name: 'ListWrapper',
  components: {
    ModelSelect,
    List,
    Filtering,
    BaseTableWrapper
  },

  data () {
    return {
      delay: 500,
      isFilteringVisible: false,
      casesQuantity: 0,
      caseTypeOptions: [],
      deviceTypeOptions: [],
      searchParams: {
        status: null,
        caseQuickSearch: '',
        caseType: null
      }
    }
  },

  created () {
    this.getDeviceTypes()
    this.fetchCaseTypeOptions()
  },

  beforeCreate () {
    checkPagePermission('cases', 'EXCMCaseList')
  },

  watch: {
    '$route': {
      immediate: true,
      handler () {
        this.searchParams['status'] = this.$route.fullPath.includes('open') ? 1 : [2, 3, 4]
        this.clearFilters()
      }
    },
    items: function (val) {
      this.casesQuantity = val.length
    }
  },
  directives: {
    debounce
  },
  computed: {
    ...mapGetters({
      totalItems: 'excmcase/list/totalItems'
    }),
    externalStatus () {
      if (this.$route.path.includes('open')) {
        return 1
      } else {
        return [2, 3, 4]
      }
    },
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    isSalesRepresentative () {
      return getUserRoles().roles.includes('ROLE_SALES_REPRESENTATIVE')
    },
    displayAssigned () {
      return !this.isWholesaler
    },
    mobileView () {
      return this.$store.state.mobileView
    }
  },

  methods: {
    clearFilters () {
      if (this.$refs.filtering) {
        this.searchParams.caseType = null
        this.$refs.filtering.$data.searchParams = {
          highPriority: false,
          activeOnly: true,
          status: this.externalStatus,
          state: 1,
          disableRolesFiltering: (this.isSalesRepresentative || this.isWholesaler || getUserRoles().default_disable_roles_filtering) ? 1 : 0,
          'lastTask.lastPoolTask.operationTransferUserData': null,
          'filterTaskByCustomField': '',
          caseType: null,
          idKeyUserData: null,
          'lastTask.idTaskType': [],
          'idKeyTask.idTaskType': []
        }
        this.$refs.filtering.$data.currentTaskType = []
        this.$refs.filtering.$data.keyTaskType = []
      }
    },
    getPage (params) {
      this.searchParams = params
    },
    async getDeviceTypes () {
      let params = {
        'pagination': false,
        'state': 1
      }
      this.deviceTypeOptions = []
      const response = await new ApiService('e_x_c_m_device_types', params).getResults()
      this.deviceTypeOptions = response.items
      let nullOption = {
        '@id': null,
        title: this.$t('global.allOptions')
      }
      this.deviceTypeOptions.unshift(nullOption)
    },
    async fetchCaseTypeOptions () {
      let params = { pagination: false, forFiltering: 1 }
      const response = await new ApiService('e_x_c_m_case_types', params).getResults()
      this.caseTypeOptions = response.items.map(type => {
        return {
          value: getId(type['@id']),
          text: type.title,
          keyTaskTypes: type.keyTaskTypes,
          keyRoles: type.keyRoles
        }
      })
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
